import React, {useContext} from 'react'
import PropTypes from 'prop-types'
import {RouterContext} from '../router/provider'
import {scrollTo} from '../scroll'

export default WrappedComponent => {
  const isLeftClickEvent = event => event.button === 0,
    isModifiedEvent = event => !!(
      event.metaKey ||
      event.altKey ||
      event.ctrlKey ||
      event.shiftKey
    ),
    HOC = props => {
      const {push} = useContext(RouterContext),
        {navigate, ...wrapperProps} = props,
        onClick = (proxy, ...args) => {
          const {onClick, href} = props

          onClick(proxy, ...args)

          if (href && navigate) {
            if (proxy.defaultPrevented) {
              return
            }

            scrollTo(0, 500)

            if (isModifiedEvent(proxy) || !isLeftClickEvent(proxy)) {
              return
            }

            proxy.preventDefault()

            push(href)
          }
        }

      return <WrappedComponent {...wrapperProps} onClick={onClick}/>
    }

  HOC.propTypes = {
    onClick: PropTypes.func,
    navigate: PropTypes.bool
  }
  HOC.defaultProps = {onClick: () => {}}
  HOC.displayName = `${WrappedComponent.displayName}WithNavigateOnClick`

  return HOC
}
